export default __webpack_public_path__ + "static/media/Q2-1.e02ef8f3.jpg";